module.exports = __webpack_public_path__ + "assets/media/day10.1aac5c21.mp3";